module.exports = __webpack_public_path__ + "static/media/vg-3.d2272244.png";